import useBatchDetail from "../../hooks/useBatchDetail";
import { useFileUploadFlow } from "../../FileUpload/hooks/useFileUploadFlow";

const INCOMPLETE_STATUSES = new Set(["PENDING_VALIDATION_ERRORS", "PENDING_APPROVAL"]);
const PRINT_ELIGIBLE_STATUSES = new Set(["COMPLETED", "PARTIALLY_COMPLETED", "PARTIALLY_PROCESSED"]);

const RESUME_BANNER_CONTENT = {
  PENDING_VALIDATION_ERRORS: {
    title: "Action Required",
    message: "This batch has unresolved errors. Fix them and submit for approval to complete the disbursement.",
  },
  PENDING_APPROVAL: {
    title: "Action Required",
    message: "This batch is ready. Submit it for approval to complete the disbursement.",
  },
};


export function useBatchResume(id, isSuperAdmin = false) {
  const {
    status: batchStatus,
    paymentChannel,
    recipientCount,
    batchId: batchDisplayId,
    isLoading: batchDetailLoading,
  } = useBatchDetail(id, isSuperAdmin);

  const { handleResume } = useFileUploadFlow();

  const isIncomplete =
    !isSuperAdmin &&
    !batchDetailLoading &&
    INCOMPLETE_STATUSES.has(batchStatus);

  const onResumeBatch = () => {
    handleResume({ id, status: batchStatus, paymentChannel, recipientCount, batchId: batchDisplayId });
  };

  const showPrint = PRINT_ELIGIBLE_STATUSES.has(batchStatus);
  const bannerTitle = RESUME_BANNER_CONTENT[batchStatus]?.title ?? null;
  const bannerMessage = RESUME_BANNER_CONTENT[batchStatus]?.message ?? null;

  return { isIncomplete, onResumeBatch, showPrint, bannerTitle, bannerMessage };
}
